import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomTranslationsService, STATE } from 'src/app/operational-data-common/translations';

import {
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  HeatingRodHeatingCommands,
  HeatingRodHeatingProperties,
  HeatingRodStatisticsProperties,
  HeatingRodStatusProperties,
} from '@vi-iot/client';

import { Helpers, InstallationFeaturesStore } from '@store';

import { SUFFIX } from '../../../shared/common/units';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-electric-heater',
  templateUrl: './electric-heater.component.html',
  styleUrls: ['./electric-heater.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElectricHeaterComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  heatingRodHeating$: Observable<Feature<HeatingRodHeatingProperties, HeatingRodHeatingCommands>>;
  heatingRodDhw$: Observable<Feature<HeatingRodHeatingProperties, HeatingRodHeatingCommands>>;
  heatingRodStatus$: Observable<Feature<HeatingRodStatusProperties, never>>;
  heatingConfigurationDhwHeater$: Observable<
    Feature<HeatingRodHeatingProperties, HeatingRodHeatingCommands>
  >;
  heatingRodStatistics$: Observable<Feature<HeatingRodStatisticsProperties, never>>;

  availableOverlays = FeaturesDetailsOverlayTypeEnum;
  getHeatingRodStatusValue = Helpers.getHeatingRodStatusValue;
  STATE = STATE;
  SUFFIX = SUFFIX;

  @Input() deviceSelectId: string;
  @Input() deviceId: string;

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    protected customTranslationsService: CustomTranslationsService
  ) {}

  ngOnInit(): void {
    this.heatingRodHeating$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingRodHeating,
      this.deviceId
    );
    this.heatingRodDhw$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingRodDhw,
      this.deviceId
    );
    this.heatingRodStatus$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingRodStatus,
      this.deviceId
    );

    this.heatingConfigurationDhwHeater$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingConfigurationDhwHeater,
      this.deviceId
    );

    this.heatingRodStatistics$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingRodStatistics
    );
  }
}
